"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const keys_1 = __importDefault(require("lodash/keys"));
const reduce_1 = __importDefault(require("lodash/reduce"));
const size_1 = __importDefault(require("lodash/size"));
const mobx_1 = require("mobx");
const mapInitialStateToStoreState_1 = __importDefault(require("../utils/store/mapInitialStateToStoreState"));
class ABTestingStore {
    constructor(initialState = {}) {
        this.abKeyMap = {};
        /**
         * Assigns AB store properties to window
         * to make them global for console
         */
        this.makeABStoreGlobal = () => {
            const { activateABKey, deactivateABKey, setABKeys, getActiveABKeys } = this;
            Object.assign(global, {
                activateABKey,
                deactivateABKey,
                setABKeys,
                getActiveABKeys,
            });
        };
        /**
         * Get active AB key names
         * @returns {Array}
         */
        this.getActiveABKeys = () => {
            return (0, reduce_1.default)(this.abKeyMap, (result, value, key) => {
                if (value) {
                    result.push(key);
                }
                return result;
            }, []);
        };
        /**
         * Activate single AB key
         * @param {String} key
         */
        this.activateABKey = (key) => {
            this.abKeyMap = Object.assign(Object.assign({}, this.abKeyMap), { [key]: true });
        };
        /**
         * Deactivate single AB key
         * @param {String} key
         */
        this.deactivateABKey = (key) => {
            this.abKeyMap = Object.assign(Object.assign({}, this.abKeyMap), { [key]: false });
        };
        /**
         * Activate/Deactivate multiple AB keys
         * @param {Object} keyMap
         */
        this.setABKeys = (keyMap) => {
            this.abKeyMap = Object.assign(Object.assign({}, this.abKeyMap), keyMap);
        };
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.updateInitialState(initialState);
        this.makeABStoreGlobal();
    }
    /**
     * Get total AB key count
     * @returns {Number}
     */
    get totalCount() {
        return (0, size_1.default)((0, keys_1.default)(this.abKeyMap));
    }
}
__decorate([
    mobx_1.observable
], ABTestingStore.prototype, "abKeyMap", void 0);
__decorate([
    mobx_1.computed
], ABTestingStore.prototype, "totalCount", null);
__decorate([
    mobx_1.action.bound
], ABTestingStore.prototype, "activateABKey", void 0);
__decorate([
    mobx_1.action.bound
], ABTestingStore.prototype, "deactivateABKey", void 0);
__decorate([
    mobx_1.action.bound
], ABTestingStore.prototype, "setABKeys", void 0);
__decorate([
    mobx_1.action.bound
], ABTestingStore.prototype, "updateInitialState", void 0);
exports.default = ABTestingStore;
